// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_v7-0";
export var checkoutRateBadgeLink = "_v7-1";